import React from 'react'
import { FieldArray } from 'redux-form'
import VideosUploader from './VideosUploader'
import { I18n } from 'react-i18next'


const arrayToObject = (array= []) =>
    array.reduce((obj, item) => {
        obj[item.id] = item
        return obj
    }, {})

const VisualComponent = ({fields:{ push, remove, getAll, insert }, module, user, accessId, groupModel, placeholder, tKey, editable}) => {
    const objects = getAll()
    const allIds = objects && objects.map(o => o.id)
    const byId = arrayToObject(objects)

    const updateVideo = (index, newVideo) => {
        if (index >= 0) {
            // Replace existing video
            remove(index)
            insert(index, newVideo)
        }
    }

    return (
        <I18n ns={[module.model, 'platform']}>
            {t =>
                <VideosUploader
                    byId={byId}
                    allIds={allIds}
                    push={push}
                    remove={remove}
                    updateVideo={updateVideo}
                    t={t}
                    user={user}
                    accessId={accessId}
                    groupModel={groupModel}
                    editable={editable}
                    placeholder={placeholder}
                    tKey={tKey}
                />
            }
        </I18n>

    )
}

// binding for redux-form
const VideosUploaderField = ({ field, module, user, accessId, groupModel }) => {
    return (
        <FieldArray
            name={field.path}
            tKey={field.tKey}
            placeholder={field.placeholder}
            component={VisualComponent}
            module={module}
            rerenderOnEveryChange={true}
            user={user}
            accessId={accessId}
            groupModel={groupModel}
            editable={field.editable}
        />
    )
}


export default VideosUploaderField
